import { atom } from "recoil";

const photoTwoState =atom({
    key: 'photoTwo',
    default: false
})

export default photoTwoState